import { Edition } from '@atlassian/touchpoint-commons-event-analytics/types';

import type { DialogConfig } from '../shared/types';

export const PREMIUM_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'payment-details-popup',
	dialogType: 'pop-up',
	targetProductEdition: Edition.PREMIUM_EDITION,
};

export const STANDARD_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'payment-details-popup',
	dialogType: 'pop-up',
	targetProductEdition: Edition.STANDARD_EDITION,
};
